import client from '@shared/utils/client-rest'

import router, {MODES}       from '@app/router'
import { makeBypassableCache } from './in-memory-cache.js'
import { isModelCacheEnabled } from '@client-shared/utils/cache-bypass'



class Cache{

	constructor(){
		// Search caches query results (no specs). SPECS_CACHE is present for symmetry with the
		// dev-tools UI; nothing writes to it.
		this.SPECS_CACHE = makeBypassableCache('search', 'specs')
		this.METRICS_CACHE = makeBypassableCache('search', 'metrics')
		this.should_update_cache = false
	}

	refetch(){
		this.SPECS_CACHE = makeBypassableCache('search', 'specs')
		this.METRICS_CACHE = makeBypassableCache('search', 'metrics')
		this.should_update_cache = true
	}

	finishUpdateCache() {
		this.should_update_cache = false
	}


	async fetch(customer_id, search_token, options){

		const modes = options?.modes

		// TEMP BEGIN - Require a mode for now
		if (!modes || !modes.length) return console.error('Search: At least 1 mode must be provided. Cancelling search.')
		// TEMP END - Require a mode for now

		if (modes && modes.every(m => !Object.values(MODES).includes(m))) return console.error('Search: Invalid mode. Cancelling search.')

		if (!search_token) return null

		const cache_key = customer_id + search_token + modes.join('')
		const cached = this.METRICS_CACHE[cache_key]

		if(cached && !options?.update_cache && isModelCacheEnabled('search', 'metrics')) return cached

		// Abort previous search request
		if (this.prev_xhr != null) this.prev_xhr.abort()
		this.prev_xhr = null


		return client(`/api/v1/search/catalog`, {
			params: {
				search: search_token,
				customer_id,
				solution_types: modes,
				entity_types: undefined,
			},
			config: (xhr) => {
				// Store ref to previous search request to allow abort
				this.prev_xhr = xhr
			},
		})
		.then(async results => {

			this.METRICS_CACHE[cache_key] = results

			return results
		})

	}


}



export default new Cache()
